import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './adm_oet_meet.css';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import UnderConstruction from '../../../components/UnderConstruction';
import { FaLanguage } from 'react-icons/fa';
import { db, auth } from '../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../../auth/cache_manager';

function AdminOETMeetings() {
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);
  
  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };
  
  return (
    <div className={`adm_oet_meet_container ${isDarkMode ? 'adm_oet_meet_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <div className="adm_oet_meet_content">
        <div className="adm_oet_meet_header">
          <div className="adm_oet_meet_title_container">
            <h1>
              <FaLanguage style={{ marginRight: '12px', verticalAlign: 'middle' }} />
              OET Meetings Management
            </h1>
            <div className="adm_oet_meet_title_underline"></div>
          </div>
        </div>
        
        {/* # Using UnderConstruction component */}
        <UnderConstruction pageName="OET Meetings Management" isDarkMode={isDarkMode} />
      </div>
      
      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default AdminOETMeetings;
